import React from "react";

export const FireExtinguisher: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="30" cy="30" r="27" fill="#D1D5D9" stroke="#E8ECEF" strokeWidth="6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.6529 11.7753C34.2767 11.941 34.7992 12.3665 35.0879 12.9437C36.1759 15.1198 36.9879 16.4404 37.8048 17.5112C38.6318 18.5951 39.5065 19.4825 40.8371 20.8131C43.9121 23.888 45.4502 27.9227 45.4502 31.95C45.4502 35.9773 43.9121 40.012 40.8371 43.0869C34.6864 49.2377 24.714 49.2377 18.5633 43.0869C15.4883 40.012 13.9502 35.9773 13.9502 31.95C13.9502 27.9227 15.4883 23.888 18.5633 20.8131C19.2068 20.1696 20.1745 19.9771 21.0153 20.3253C21.8561 20.6736 22.4043 21.494 22.4043 22.4041C22.4043 24.9236 22.5616 26.8435 23.2985 28.3748C23.7037 29.2168 24.3359 30.04 25.4253 30.7746C25.6855 28.3879 26.1621 25.48 26.8061 22.7199C27.3132 20.5468 27.9438 18.3773 28.6944 16.5682C29.0699 15.6633 29.4944 14.8017 29.9766 14.0577C30.4459 13.3336 31.049 12.5968 31.8273 12.0778C32.3643 11.7199 33.0292 11.6097 33.6529 11.7753ZM34.4732 41.2229C31.8371 43.859 27.5633 43.859 24.9272 41.2229C23.6092 39.9049 22.9502 38.1774 22.9502 36.45C22.9502 36.45 24.9272 37.5749 28.5753 37.5749C28.5753 35.3249 29.7003 28.5749 31.3878 27.4499C32.5128 29.6999 33.1551 30.359 34.4732 31.677C35.7912 32.995 36.4502 34.7225 36.4502 36.45C36.4502 38.1774 35.7912 39.9049 34.4732 41.2229Z"
      fill="#F87171"
    />
    <rect
      x="46.1221"
      y="10.0595"
      width="2.4"
      height="51.6"
      transform="rotate(45 46.1221 10.0595)"
      fill="#E8ECEF"
      stroke="#E8ECEF"
      strokeWidth="0.6"
    />
  </svg>
);
